import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useLocation, useNavigate } from 'react-router-dom';
import * as Common from "../../Common";
import Dialog from '../../Dialog';
import LocationSelector from "../../LocationSelector";
import LoginHeader from '../../Login_header';
import Menu from '../../Menu';


const Rep_valuation = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dropdownType = location.state?.dropdownType;
    const sid = sessionStorage.getItem('sessionId');
    const branchDisable = sessionStorage.getItem('branchDisable');
    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState('');

    const [valuationTillDate, setValuationTillDate] = useState(new Date());
    const [GenerateType, setGenerateType] = useState("V");

    const [locationCode, setLocationCode] = useState(0);
    const [selectedItems, setSelectedItems] = useState([]);
    const [radioType, setRadioType] = useState("O");
    const [scr, setScr] = useState("");
    const [repLevel, setRepLevel] = useState("G");
    const [filterCN, setFilterCN] = useState(true);
    const [filterVTM, setFilterVTM] = useState(true);
    const [filterEVTM, setFilterEVTM] = useState(true);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', dropdownType === 'GLOBAL' ? 'REP_VALUATION_GLOBAL' : 'REP_VALUATION_LOCAL'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const handleDataFromChild = (newLocationCode, newSelectedItems, newRadioType) => {
        setLocationCode(newLocationCode);
        setSelectedItems(newSelectedItems);
        setRadioType(newRadioType);
    }

    const handleGenerate = () => {
        $(".loader").show();
        var msg = [], i = 0;
        if ((radioType === 'O' && locationCode === '0') || (radioType == 'S' && selectedItems == []) || (filterCN === false && filterVTM === false && filterEVTM === false)) {
            msg[i++] = ((radioType == 'O' && locationCode == '0') ? "Please select location." : '');
            msg[i++] = ((radioType == 'S' && selectedItems == []) ? "Please select atleast one location." : '');
            msg[i++] = (filterCN === false && filterVTM === false && filterEVTM === false ? "Please select atleast one CN/VTM/EVTM." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                tillDate: Common.dateYMD(valuationTillDate),
                type: GenerateType,
                radioTypeLocation: radioType,
                location: locationCode,
                multipleLocation: selectedItems,
                tillDateDMY: Common.dateDMY(valuationTillDate),
                repLevelGlobal: dropdownType === 'GLOBAL' ? true : false,
                repLevelLocal: dropdownType === 'GLOBAL' ? false : true,
                filterCN: dropdownType === 'GLOBAL' ? false : filterCN,
                // filterTC: filterTC,
                filterVTM: filterVTM,
                filterEVTM: filterEVTM,
                filterDD: true,
                filterTT: true,
                showHeader: dropdownType === 'GLOBAL' ? false : true,
            };
            if (GenerateType === 'D') {
                Common.callDownloadApiPost1(Common.apiValuation, "post", [sid, "valuationDownloadReport", JSON.stringify(obj)], result => {
                    console.log("this is result ", result);
                    $(".loader").hide();
                    setMsgText(Common.buildMessageFromArray([result]));
                    setMsgBox(true);
                });
            } else {
                Common.callApi(Common.apiValuation, [sid, "valuationViewReport", JSON.stringify(obj)], result => {
                    var newWindow = window.open();
                    newWindow.document.write(result);
                    $(".loader").hide();
                });

            }
        }
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>Report Valuation</h3>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>

                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Level<span className="text-danger">*</span></Form.Label>
                            <Form.Select disabled={true} value={repLevel} onChange={e => setRepLevel(e.target.value)}
                                required>
                                {dropdownType === 'GLOBAL' ?
                                    <option value="G">Global</option> :
                                    <option value="L">Local</option>
                                }
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label> Till Date<span className="colorThemeRed">*</span></Form.Label><br />
                            <DatePicker className="form-control"
                                selected={valuationTillDate}
                                onChange={(date) => setValuationTillDate(date)}
                                dateFormat="dd/MM/yyyy"
                                showYearDropdown
                                showMonthDropdown
                                useShortMonthInDropdown
                                dropdownMode="select"
                                peekNextMonth
                                customInput={
                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                }
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Mode<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={GenerateType} onChange={e => setGenerateType(e.target.value)}
                                required>
                                <option value="V">View</option>
                                <option value="D">Download</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    {(dropdownType === 'LOCAL' || dropdownType === 'GLOBAL') ? <>
                        {dropdownType === 'LOCAL' ?
                            <Col className="col-md-1 col-1">
                                <Form.Check
                                    size='sm'
                                    type="checkbox"
                                    label="CN"
                                    checked={filterCN}
                                    onChange={() => setFilterCN(!filterCN)}
                                />
                            </Col> : null
                        }
                        <Col className="col-md-1 col-1">
                            <Form.Check
                                size='sm'
                                type="checkbox"
                                label="EVTM"
                                checked={filterEVTM}
                                onChange={() => setFilterEVTM(!filterEVTM)}
                            />
                        </Col>
                        <Col className="col-md-1 col-1">
                            <Form.Check
                                size='sm'
                                type="checkbox"
                                label="VTM"
                                checked={filterVTM}
                                onChange={() => setFilterVTM(!filterVTM)}
                            />
                        </Col> </> : null}
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col className='col-md-6 col-6'>
                        <Form.Label>Location Filter</Form.Label><br />
                        <LocationSelector onDataFromChild={handleDataFromChild} />
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleGenerate}>Generate</Button>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
            </Container>
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
        </>
    )
}

export default Rep_valuation;
